import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './store/';
import { ThemeProvider } from '@mui/material';

import theme from './theme';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Provider store={store}>
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
</Provider>);

serviceWorker.unregister();
